module.exports = "/_next/static/images/DevelopOnSegment@3x-8bd3c817ed506c3a8f9e911848f86d06.webp";